import { render, staticRenderFns } from "./JobProject.vue?vue&type=template&id=72063fa7&scoped=true"
import script from "./JobProject.vue?vue&type=script&lang=js"
export * from "./JobProject.vue?vue&type=script&lang=js"
import style0 from "./JobProject.vue?vue&type=style&index=0&id=72063fa7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72063fa7",
  null
  
)

export default component.exports